import {Types} from './actions';
import initialState from './initialState';
import ReducerBuilder from 'classes/ReducerBuilder';
import * as ResourceActions from 'resources/actions';
import * as ResourceApi from 'api/resources';

export default ReducerBuilder.make(initialState)
  .forType(Types.REQUEST_ENTRIES)
  .reduce((state, action) => {
    state.fetchingPrize = true;
    state.fetchingEntries = true;
    state.currentPrizeId = action.prizeId;
  })
  .forType(Types.RECEIVED_PRIZE)
  .reduce((state, action) => {
    state.fetchingPrize = false;
  })
  .forType(Types.RECEIVED_ENTRIES)
  .reduce((state, action) => {
    state.fetchingEntries = false;
  })
  .forType(Types.SUBMIT_SELECT_WINNERS)
  .reduce((state, action) => {
    state.selectingWinners = true;
  })
  .forType(Types.SELECT_WINNERS_SUCCESS)
  .reduce((state, action) => {
    state.selectingWinners = false;
  })
  .forType(Types.SELECT_WINNERS_ERROR)
  .reduce((state, action) => {
    state.selectingWinners = false;
  })

  // DOWNLOAD_REPORT
  .forType(Types.DOWNLOAD_REPORT)
  .reduce((state, action) => {
    state.downloadingEntries = true;
  })
  .forType(Types.DOWNLOAD_REPORT_SUCCESS)
  .reduce((state, action) => {
    state.downloadingEntries = false;
    state.reportResponses = [{type: 'Prize Entries', success: true}];
  })
  .forType(Types.DOWNLOAD_REPORT_ERROR)
  .reduce((state, action) => {
    state.downloadingEntries = false;
    state.reportResponses = [{type: 'Prize Entries', success: false}];

  })
  .forType(Types.DOWNLOAD_REPORT_CLEAR_MODAL)
  .reduce((state, action) => {
    state.downloadingEntries = false;
    state.reportResponses = [];
  })


  .forType(Types.START_MANUAL_ENTRY)
    .reduce((state) => {
        state.manualEntryModalOpen = true;
    })
    .forType(Types.END_MANUAL_ENTRY)
    .reduce((state) => {
        state.manualEntryModalOpen = false;
        state.breakSearchText = "";
        state.breakSearchResults = [];
    })
    .forType(Types.SUBMIT_MANUAL_ENTRY)
    .reduce((state) => {
        state.submittingManualEntry = true;
    })
    .forType(Types.SUBMIT_MANUAL_ENTRY_SUCCESS)
    .reduce((state) => {
        state.manualEntryModalOpen = false;
        state.submittingManualEntry = false;
        state.breakSearchText = "";
        state.breakSearchResults = [];
    })
    .forType(Types.UPDATE_MANUAL_ENTRY_BREAK_SEARCH)
    .reduce((state, {text}) => {
        state.breakSearchText = text;
    })
    .forType(Types.MANUAL_ENTRY_BREAK_SEARCH_RESULTS_SUCCESS)
    .reduce((state, {results}) => {
        state.breakSearchResults = results;
    })
  .build();



// WEBPACK FOOTER //
// ./public/pages/ListEntries/reducer.js